import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { HomePage } from './pages/HomePage';
import { ArticlesPage } from './pages/ArticlesPage';
import { ArticleDetailPage } from './pages/ArticleDetailPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { KontaktPage } from './pages/KontaktPage';
import { HaftungsausschlussPage } from './pages/HaftungsausschlussPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col font-body text-vita-text bg-vita-cream" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/artikel" element={<ArticlesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/artikel/:slug" element={<ArticleDetailPage data-id="element-10" />} data-id="element-9" />
            <Route path="/impressum" element={<ImpressumPage data-id="element-12" />} data-id="element-11" />
            <Route path="/datenschutz" element={<DatenschutzPage data-id="element-14" />} data-id="element-13" />
            <Route path="/kontakt" element={<KontaktPage data-id="element-16" />} data-id="element-15" />
            <Route path="/haftungsausschluss" element={<HaftungsausschlussPage data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
        <CookieConsent data-id="element-20" />
      </div>
    </BrowserRouter>;
}